import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useAuthStore } from "#imports";
import en from '@/languages/en.json';
import es from '@/languages/es.json';

export const useAppStore = defineStore("appStore", () => {
  const isMobile = ref<any>();
  const isMenu = ref<boolean>(!isMobile.value);

  const brandIcon = computed(() => { return '$mdi-calendar-arrow-right'; });
  const siteName = computed(() => { return 'Red Shift'; });
  const tagLine = computed(() => { return 'Simple Shift Scheduling'; });

  const { profile } = storeToRefs(useAuthStore());
  const userLang: string = navigator.language.substring(0, 2);

  const txt = computed(() => { 
    const lang_id = profile.value && profile.value.lang_id ? profile.value.lang_id : userLang;
    window.document.getElementsByTagName('html')[0].setAttribute('lang', lang_id);
    switch (lang_id) {
      case 'es': return { ...es };
      default: return { ...en };
    }
  });
  
  const langs = ref<Array<any>>([
    { id: 'en', name: txt.value.english },
    { id: 'es', name: txt.value.spanish }
  ]);

  return {
    brandIcon, isMenu, isMobile, langs, siteName, tagLine, txt
  };
},
{
  persist: {
    omit: ['isMobile', 'isMenu', 'langs', 'txt', 'userLang']
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}